import React from 'react';
import { Link } from 'react-router-dom';
import './DownloadApp.css';

function DownloadApp() {
  return (
    <div className="download-page">
      <header className="download-header">
        <div className="header-content">
          <img src="/logoBrivefood.png" alt="BriveFood" className="logo" />
          <h1 className="main-title">BriveFood</h1>
        </div>
        <div className="header-wave">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#F9FAFB"/>
          </svg>
        </div>
      </header>

      <main className="download-content">
        <section className="app-showcase">
          <div className="showcase-text">
            <h2>Téléchargez l'application</h2>
            <p>
              Commandez vos plats préférés en quelques clics et faites-vous livrer
              directement chez vous. Rapide, simple et délicieux !
            </p>

            <ul className="features-list">
              <li>
                <span className="feature-icon">🍔</span>
                <span>Large choix de plats savoureux</span>
              </li>
              <li>
                <span className="feature-icon">🚀</span>
                <span>Livraison rapide à domicile</span>
              </li>
              <li>
                <span className="feature-icon">🎁</span>
                <span>Programme de fidélité exclusif</span>
              </li>
            </ul>
          </div>

          <div className="store-buttons">
            <a
              href="https://apps.apple.com/fr/app/brivefood/id6752569193"
              target="_blank"
              rel="noopener noreferrer"
              className="store-button app-store"
            >
              <div className="store-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
              </div>
              <div className="store-text">
                <span className="store-label">Télécharger sur</span>
                <span className="store-name">App Store</span>
              </div>
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.brivefood.app&hl=fr_CH"
              target="_blank"
              rel="noopener noreferrer"
              className="store-button play-store"
            >
              <div className="store-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                </svg>
              </div>
              <div className="store-text">
                <span className="store-label">Disponible sur</span>
                <span className="store-name">Google Play</span>
              </div>
            </a>
          </div>

          <div className="showcase-image">
            <div className="phone-mockup">
              <div className="phone-screen">
                <img src="/logoBrivefood.png" alt="BriveFood App" className="app-preview" />
              </div>
            </div>
          </div>
        </section>

        <section className="how-it-works">
          <h2>Comment ça marche ?</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Téléchargez</h3>
              <p>Installez l'app BriveFood sur votre smartphone</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Choisissez</h3>
              <p>Parcourez notre menu et sélectionnez vos plats</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Commandez</h3>
              <p>Validez votre panier et commandez</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Dégustez</h3>
              <p>Recevez votre commande et régalez-vous !</p>
            </div>
          </div>
        </section>
      </main>

      <footer className="download-footer">
        <div className="footer-content">
          <div className="footer-brand">
            <img src="/logoBrivefood.png" alt="BriveFood" className="footer-logo" />
            <p>BriveFood - Votre restaurant à portée de main</p>
          </div>
          <div className="footer-contact">
            <a href="mailto:Brivefood@gmail.com" className="footer-email">
              <span className="email-icon">✉</span>
              Brivefood@gmail.com
            </a>
          </div>
          <div className="footer-links">
            <Link to="/politique-de-confidentialite">Politique de Confidentialité</Link>
            <Link to="/conditions-generales">Conditions Générales d'Utilisation</Link>
          </div>
        </div>
        <p className="copyright">&copy; {new Date().getFullYear()} BriveFood. Tous droits réservés.</p>
      </footer>
    </div>
  );
}

export default DownloadApp;
